import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { ApplicationListClass } from './application-list-class'

export default function ApplicationList(props) {
  const [recruitment] = useOutletContext()
  return <ApplicationListClass {...props} recruitment={recruitment} />
}
